import React, {Component} from 'react';
import {Col, Container, Form, Input, InputGroup, Row} from 'reactstrap';
import '../../scss/Login.css'
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import ToastHelper from "../../utils/ToastHelper";
import SFXButtonComponent from "../../components/SFXButtonComponent";
import UserSessionService from "../../services/UserSessionService";
import {Link, withRouter} from "react-router-dom";

class Login extends Component {

    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: ''
        };

        this.handleResize = this.handleResize.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.isMobile = this.isMobile.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        if (window) window.addEventListener('resize', this.handleResize);
        this.props.history.replace("/login")
    }

    validateForm() {
        return this.state.username.length > 0 && this.state.password.length > 0;
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit = function (event) {
        event.preventDefault();
        this.setState({isLoading: true});
        let self = this;

        UserSessionService.login(this.state.username, this.state.password).then(function (response) {

            if (response === "Forbidden") {
                ToastHelper.error("Maximum number of authentication attempts exceeded, please retry later.");
                self.setState({isLoading: false, password: ""});
            } else if (response) {
                self.props.onUserAuthenticated();

            } else {
                ToastHelper.error("Incorrect Username or Password");
                self.setState({isLoading: false, password: ""});
            }
        });
    }

    isMobile() {
        return window.innerWidth < 575;
    }

    handleResize() {
        if (window) {
            this.setState({mobile: this.isMobile()});
        }
    }

    componentWillUnmount() {
        if (window) window.removeEventListener('resize', this.handleResize);
    }


    render() {

        const logo =
            <div className={"logo-container"}>
                <img className={"logo"}
                     src={"/images/ria-logo.png"}
                     alt=""
                />
            </div>;

        return (
            <div className={"backDrop"}>
                <div className="app flex-row align-items-center">
                    <Container>
                        <Row>
                            <Col>
                                {logo}
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"logo-center"}>
                        <Row className="justify-content-center">
                            <Col md="8">
                                <Form className={"loginForm"} onSubmit={this.handleSubmit}>
                                    <main>
                                        <ToastContainer position="top-right" autoClose={5000}
                                                        style={{zIndex: 1999}}/>
                                    </main>
                                    <Col>
                                        <InputGroup className="mb-3">
                                            <Input className="form-control input-lg"
                                                   type="text"
                                                   placeholder="Username"
                                                   autoComplete="username"
                                                   id="username"
                                                   autoFocus
                                                   onChange={this.handleChange}
                                                   value={this.state.username}/>
                                        </InputGroup>
                                        <InputGroup className="mb-3">
                                            <Input className="form-control input-lg"
                                                   type="password"
                                                   placeholder="Password"
                                                   id="password"
                                                   autoComplete="current-password"
                                                   onChange={this.handleChange}
                                                   value={this.state.password}/>
                                        </InputGroup>
                                        <Row className="mb-3"
                                             style={{paddingRight: "15px", paddingLeft: "15px"}}
                                        >
                                            <SFXButtonComponent className="btn btn-lg btn-block btn-primary signIn"
                                                                disabled={!this.validateForm()}>
                                                Sign in
                                            </SFXButtonComponent>
                                        </Row>
                                        <div className={"forgotPassword"}>
                                            <Link to={"/reset-password"}>
                                                Forgot Password
                                            </Link>
                                        </div>
                                    </Col>
                                </Form>
                            </Col>
                        </Row>
                    </Container>
                </div>
                 <div className={"powered-by"}>
                    <p>Powered by Sikhona Forex</p>
                </div>
            </div>
        );
    }
}

export default withRouter(Login);
